"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const enums_1 = require("../enums");
const utils_1 = __importDefault(require("../utils"));
var PIDType;
(function (PIDType) {
    PIDType[PIDType["THAI"] = 0] = "THAI";
    PIDType[PIDType["L_POP"] = 1] = "L_POP";
    PIDType[PIDType["ALIEN"] = 2] = "ALIEN";
    PIDType[PIDType["UN"] = 3] = "UN";
})(PIDType = exports.PIDType || (exports.PIDType = {}));
const STR_FORMAT_THAI = '0-0000-00000-00-0';
const STR_FORMAT_ALIEN = '00-0000-000000-0';
const STR_FORMAT_UN = '000-0000-00000-0';
const getAutoPIDFormat = (idStr) => {
    let strFormat = STR_FORMAT_THAI;
    if (idStr.substr(0, 3) === '000') {
        strFormat = STR_FORMAT_UN;
    }
    else if (idStr.substr(0, 2) === '00') {
        strFormat = STR_FORMAT_ALIEN;
    }
    return strFormat;
};
const pid = {
    getFormat(id, digitType, formatType) {
        const idStr = utils_1.default.padToIdString(id, digitType, true);
        let strFormat = '';
        switch (formatType) {
            case enums_1.FormatType.AUTO:
                strFormat = getAutoPIDFormat(idStr);
                break;
            case enums_1.FormatType.THAI:
                strFormat = STR_FORMAT_THAI;
                break;
            case enums_1.FormatType.ALIEN:
                strFormat = STR_FORMAT_ALIEN;
                break;
            case enums_1.FormatType.UN:
                strFormat = STR_FORMAT_UN;
                break;
            default:
                throw new Error('ประเภท format ไม่ถูกต้อง');
        }
        return utils_1.default.formatWithFormatType(idStr, strFormat);
    },
    getDataType(id, digitType) {
        const idStr = utils_1.default.padToIdString(id, digitType, true);
        if (idStr.substr(0, 3) === '000') {
            return PIDType.UN;
        }
        else if (idStr.substr(0, 2) === '00') {
            return PIDType.ALIEN;
        }
        else if (idStr.substr(0, 1) === '0') {
            return PIDType.L_POP;
        }
        else {
            return PIDType.THAI;
        }
    },
};
exports.default = pid;
